import { FIELDS } from "lib"

export const USER_TABLE_COLUMNS = [
    { id: 'rol', label: 'Rol de Usuario' },
    { id: FIELDS.name.key, label: FIELDS.name.name },
    { id: FIELDS.email.key, label: FIELDS.email.name },
    { id: FIELDS.identification.key, label: FIELDS.identification.name },
    { id: 'creacion', label: 'Capacidad de Creacion' },
]